export default __webpack_public_path__ + "00d2c105895e1a507920d55f847d2861.png";